import ShareCodeError from './ShareCodeError';

export default ShareCodeError;
